import { useSelector, useDispatch } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import swal from "sweetalert";
import {
  createReviewAction,
  clearErrorAction,
} from "../../redux/actions/reviewAction";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@material-ui/core";
import { Rating } from "@material-ui/lab";
import ReactStars from "react-rating-stars-component";
import { CREATE_REVIEW_RESET } from "../../redux/constants/reviewConstants";
import Loader from "../../layout/loader";
import "./review.css";

function Reviews({ id, reviews, productStock }) {
  // console.log(reviews)

  const { isAuthenticated, loading: loadingUser } = useSelector(
    (state) => state.user
  );

  const { loading, error, success } = useSelector(
    (state) => state.reviewCreate
  );

  // redux functions
  const dispatch = useDispatch();

  // review state
  const [review, setreview] = useState("");
  const [images, setImages] = useState("");
  const [rating, setRating] = useState(0);
  const [open, setOpen] = useState(false);
  const [expandedReviews, setExpandedReviews] = useState({});
  const reviewCount = reviews ? reviews.length : 0;
  const averageRating = reviewCount
    ? (
        reviews.reduce((total, reviewData) => total + Number(reviewData.rating || 0), 0) /
        reviewCount
      ).toFixed(1)
    : "0.0";

  // const [imagesLength, setImagesLength] = useState()
  // console.log(imagesLength)

  useEffect(() => {
    if (error) {
      swal({
        title: "Error",
        text: error,
        icon: "error",
      });
      dispatch(clearErrorAction(error));
    }

    if (success) {
      swal({
        title: "Success",
        text: success,
        icon: "success",
      });
      dispatch({ type: CREATE_REVIEW_RESET });
      window.location.reload();
    }
  }, [dispatch, error, success]);

  // review submit handler

  const submitReviewToggle = (e) => {
    e.preventDefault();
    open ? setOpen(false) : setOpen(true);
  };

  const toggleReviewExpand = (index) => {
    setExpandedReviews((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const onChangeFile = (e) => {
    setImages(e.target.files);
  };

  const submitDataHandler = (e) => {
    e.preventDefault();
    if (!isAuthenticated === true) {
      return swal({
        title: "Validation",
        text: "login please !!",
        icon: "info",
      });
    } else {
      if (!review || !rating || !images) {
        return swal({
          title: "Validation Error",
          text: "can't review without all fields",
          icon: "info",
        });
      } else {
        const formData = new FormData();
        formData.append("review", review);
        formData.append("productId", id);
        formData.append("rating", rating);
        for (let index = 0; index < images.length; index++) {
          formData.append("image", images[index]);
        }

        dispatch(createReviewAction(formData));
        setOpen(false);
        setreview("");
        setImages("");
        setRating(0);
      }
    }
  };

  return (
    <Fragment>
      {/* REVIEW HEADING */}
      <div
        className="review-heading review-heading-modern"
        style={{
          textAlign: "center",
          marginTop: "60px",
          marginBottom: "40px",
        }}
      >
        <h2
          style={{
            fontSize: "2.4rem",
            fontWeight: "700",
            color: "#111",
            letterSpacing: "1px",
          }}
        >
          Customer Reviews
        </h2>

        <p
          style={{
            color: "#777",
            marginTop: "10px",
            fontSize: "1rem",
          }}
        >
          Real feedback from customers who purchased this product
        </p>
      </div>

      <div className="review-summary-panel">
        <div className="review-score-card">
          <span className="review-score-value">{averageRating}</span>
          <ReactStars
            edit={false}
            color={"#d1d5db"}
            activeColor={"#facc15"}
            size={22}
            value={Number(averageRating)}
            isHalf={true}
          />
          <span className="review-score-text">{reviewCount} customer reviews</span>
        </div>
        <div className="review-trust-card">
          <span>Verified customer feedback</span>
          <p>Reviews help shoppers understand fit, comfort, quality, and real product experience.</p>
        </div>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          {loadingUser ? (
            <Loader />
          ) : (
            <Fragment>
              {/* REVIEWS SECTION */}
              <section className="review-list-section">
                <div className="container">
                  <div
                    className="review-list-grid"
                    style={{
                      display: "grid",
                      gap: "25px",
                    }}
                  >
                    {reviews && reviews.length > 0 ? (
                      reviews.map((reviewData, index) => (
                        <div
                          className="review-card"
                          key={index}
                          style={{
                            background: "#fff",
                            borderRadius: "24px",
                            padding: "25px",
                            boxShadow: "0 10px 35px rgba(0,0,0,0.06)",
                            border: "1px solid #f1f1f1",
                            transition: "0.3s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                              "0 15px 45px rgba(0,0,0,0.1)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.boxShadow =
                              "0 10px 35px rgba(0,0,0,0.06)")
                          }
                        >
                          {/* USER HEADER */}
                          <div
                            className="user-details-container"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              flexWrap: "wrap",
                              gap: "15px",
                              marginBottom: "20px",
                            }}
                          >
                            {/* USER */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "14px",
                              }}
                            >
                              {/* AVATAR */}
                              <div
                                style={{
                                  width: "55px",
                                  height: "55px",
                                  borderRadius: "50%",
                                  background:
                                    "linear-gradient(135deg,#111,#444)",
                                  color: "#fff",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: "700",
                                  fontSize: "1.2rem",
                                  textTransform: "uppercase",
                                }}
                              >
                                {reviewData.name?.charAt(0)}
                              </div>

                              {/* NAME + DATE */}
                              <div>
                                <h5
                                  style={{
                                    margin: 0,
                                    fontWeight: "700",
                                    color: "#111",
                                    fontSize: "1.05rem",
                                  }}
                                >
                                  {reviewData.name}
                                </h5>

                                <span
                                  style={{
                                    color: "#888",
                                    fontSize: "0.9rem",
                                  }}
                                >
                                  Posted on {reviewData.date}
                                </span>
                              </div>
                            </div>

                            {/* STARS */}
                            <div className="review-sections">
                              <ReactStars
                                edit={false}
                                color={"#d1d5db"}
                                activeColor={"#facc15"}
                                size={window.innerWidth < 600 ? 20 : 24}
                                value={reviewData.rating}
                                isHalf={true}
                              />
                            </div>
                          </div>

                          {/* REVIEW TEXT */}
                          <div
                            className="review-details-container"
                            style={{
                              marginBottom: "20px",
                            }}
                          >
                            <p
                              style={{
                                color: "#444",
                                lineHeight: "1.9",
                                fontSize: "1rem",
                                margin: 0,
                                display: "-webkit-box",
                                WebkitLineClamp: expandedReviews[index]
                                  ? "unset"
                                  : 3,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}
                            >
                              {reviewData.review}
                            </p>
                            {reviewData.review?.length > 150 && (
                              <span
                                onClick={() => toggleReviewExpand(index)}
                                style={{
                                  color: "#007bff",
                                  fontSize: "0.85rem",
                                  fontWeight: "600",
                                  cursor: "pointer",
                                  marginTop: "8px",
                                  display: "inline-block",
                                }}
                              >
                                {expandedReviews[index]
                                  ? "Show Less"
                                  : "Read Full Review"}
                              </span>
                            )}
                          </div>

                          {/* REVIEW IMAGES */}
                          {reviewData.image && reviewData.image.length > 0 && (
                            <div
                              className="image-container-div"
                              style={{
                                display: "flex",
                                gap: "15px",
                                flexWrap: "wrap",
                                marginTop: "10px",
                              }}
                            >
                              {reviewData.image.map((image, i) => (
                                <div
                                  className="review-image-main-container"
                                  key={i}
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    borderRadius: "18px",
                                    overflow: "hidden",
                                    cursor: "zoom-in",
                                    border: "1px solid #eee",
                                    background: "#fafafa",
                                  }}
                                >
                                  <img
                                    src={image.imageurl}
                                    alt="review"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      transition: "0.3s ease",
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="empty-review-card">
                        <h4>No reviews yet</h4>
                        <p>Be the first customer to share your experience with this product.</p>
                      </div>
                    )}
                  </div>
                </div>
              </section>
            </Fragment>
          )}

          {/* REVIEW FORM */}
          <div
            className="main-head-form"
            style={{
              marginTop: "70px",
              marginBottom: "60px",
            }}
          >
            <div
              className="form-heading"
              style={{
                textAlign: "center",
                marginBottom: "35px",
              }}
            >
              <h3
                style={{
                  fontSize: "2rem",
                  fontWeight: "700",
                  color: "#111",
                }}
              >
                Write a Review
              </h3>

              <p
                style={{
                  color: "#777",
                  marginTop: "10px",
                }}
              >
                Share your experience about this product
              </p>
            </div>

            {/* FORM CARD */}
            <div
              className="review-form-card"
              style={{
                maxWidth: "850px",
                margin: "auto",
                background: "#fff",
                borderRadius: "30px",
                padding: "35px",
                boxShadow: "0 12px 40px rgba(0,0,0,0.08)",
                border: "1px solid #f1f1f1",
              }}
            >
              <form>
                <div className="second-main-head-form">
                  {/* TEXTAREA */}
                  <div style={{ marginBottom: "25px" }}>
                    {productStock < 1 ? (
                      <textarea
                        id="review"
                        name="review"
                        rows="6"
                        disabled
                        className="form-review-area"
                        style={{
                          width: "100%",
                          borderRadius: "18px",
                          border: "1px solid #ddd",
                          padding: "18px",
                          outline: "none",
                          resize: "none",
                          background: "#f8f8f8",
                          fontSize: "1rem",
                        }}
                      ></textarea>
                    ) : (
                      <textarea
                        id="review"
                        placeholder="Write your honest review about the product..."
                        name="review"
                        rows="6"
                        onChange={(e) => setreview(e.target.value)}
                        className="form-review-area"
                        style={{
                          width: "100%",
                          borderRadius: "18px",
                          border: "1px solid #ddd",
                          padding: "18px",
                          outline: "none",
                          resize: "none",
                          fontSize: "1rem",
                          transition: "0.3s ease",
                        }}
                      ></textarea>
                    )}
                  </div>

                  {/* FILE UPLOAD */}
                  <div
                    className="review-image-file-select-area"
                    style={{
                      marginBottom: "30px",
                    }}
                  >
                    <label
                      htmlFor="file"
                      className="choose-btn"
                      style={{
                        width: "100%",
                        border: "2px dashed #ddd",
                        borderRadius: "20px",
                        padding: "25px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        background: "#fafafa",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "700",
                          color: "#111",
                          marginBottom: "8px",
                        }}
                      >
                        Upload Review Images
                      </span>

                      <span
                        style={{
                          color: "#777",
                          fontSize: "0.9rem",
                        }}
                      >
                        PNG, JPG, JPEG
                      </span>

                      <input
                        type="file"
                        name="image"
                        accept="image/*"
                        multiple
                        onChange={onChangeFile}
                        disabled={productStock < 1}
                        style={{
                          marginTop: "15px",
                        }}
                      />
                    </label>
                  </div>

                  {/* DIALOG */}
                  <Dialog
                    aria-labelledby="simple-dialog-title"
                    open={open}
                    onClose={submitReviewToggle}
                    PaperProps={{
                      style: {
                        borderRadius: "25px",
                        padding: "20px",
                      },
                    }}
                  >
                    <DialogTitle
                      style={{
                        fontWeight: "700",
                        textAlign: "center",
                      }}
                    >
                      Rate This Product
                    </DialogTitle>

                    <DialogContent
                      className="submitDialog"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        paddingBottom: "20px",
                      }}
                    >
                      <Rating
                        onChange={(e) => setRating(e.target.value)}
                        value={rating}
                        size="large"
                      />
                    </DialogContent>

                    <DialogActions
                      style={{
                        justifyContent: "center",
                        paddingBottom: "20px",
                      }}
                    >
                      <Button color="secondary" onClick={submitReviewToggle}>
                        Cancel
                      </Button>

                      <Button color="primary" onClick={submitDataHandler}>
                        Submit
                      </Button>
                    </DialogActions>
                  </Dialog>

                  {/* BUTTON */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {loading ? (
                      <button
                        onClick={submitReviewToggle}
                        disabled
                        className="create-review-btn disabled"
                        style={{
                          width: "220px",
                          height: "58px",
                          border: "none",
                          borderRadius: "18px",
                          background: "#111",
                          color: "#fff",
                          fontSize: "1rem",
                          fontWeight: "700",
                          cursor: "not-allowed",
                          opacity: "0.7",
                        }}
                      >
                        Posting...
                      </button>
                    ) : (
                      <button
                        onClick={submitReviewToggle}
                        className="create-review-btn"
                        style={{
                          width: "220px",
                          height: "58px",
                          border: "none",
                          borderRadius: "18px",
                          background: "linear-gradient(135deg,#111,#2d2d2d)",
                          color: "#fff",
                          fontSize: "1rem",
                          fontWeight: "700",
                          cursor: "pointer",
                          boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                          transition: "0.3s ease",
                        }}
                      >
                        Post Review
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
}

export default Reviews;
